module.exports = __webpack_public_path__ + "img/Kleidung_mit_Einschussloechern_kl.3b752b15.jpg";